import { lazy } from 'react';

export const GrowthSystemPage = lazy(() => import('./GrowthSystemPage'));
